<span class="badge badge-pedido-status badge-pedido-status-producao">
    {{status.nome}}
</span>